import { toast } from 'sonner';
import { celebrateBurst } from '@/lib/celebrate';

export const STREAK_MILESTONES: readonly number[] = [7, 30, 100];

// Session-scoped guard: toggling a habit off/on again the same day recomputes
// the same streak value — without this the same milestone would re-fire.
const fired = new Set<string>();

/** Test-only reset. */
export function resetFiredMilestones(): void {
  fired.clear();
}

/**
 * Celebrate a streak landing exactly on a milestone (7/30/100 days):
 * color wave + a toast. Rare/first-time event per the motion budget, so
 * delight is allowed — but reduced-motion users get the toast only.
 */
export function maybeCelebrateStreak(habitName: string, habitId: string, streak: number): void {
  if (!STREAK_MILESTONES.includes(streak)) return;
  const key = `${habitId}:${streak}`;
  if (fired.has(key)) return;
  fired.add(key);

  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
  if (!reduced) {
    celebrateBurst();
  }
  // Voice: no exclamation marks, no emoji in toasts (🔥 belongs to the streak
  // chip only) — the wave is the celebration; the toast just names it.
  toast(`${streak}-day streak — ${habitName}`, { duration: 5000 });
}
